
import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import "../styles/Evenement.css";
import api from '../apiService/api';


const API_URL = api.API_URL + "read_events&limit=3&page=1";
const BASE_URL = api.BASE_URL;

const Evenements = () => {
  const { t, i18n } = useTranslation();
  const isArabic = i18n.language === "ar";

  const [page, setPage] = useState(1);

  const [events, setEvents] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [eventsPerPage, setEventsPerPage] = useState(3);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedMedia, setSelectedMedia] = useState(null);
  const [activeSlide, setActiveSlide] = useState(0);

  const [totalPages, setTotalPages] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  // Improved slider navigation
  const goToNextSlide = () => {
    if (selectedEvent?.mediaFiles) {
      setActiveSlide((prev) => (prev + 1) % selectedEvent.mediaFiles.length);
      setSelectedMedia(selectedEvent.mediaFiles[(activeSlide + 1) % selectedEvent.mediaFiles.length].filePath);
    }
  };

  const goToPrevSlide = () => {
    if (selectedEvent?.mediaFiles) {
      const newIndex = activeSlide === 0 ? selectedEvent.mediaFiles.length - 1 : activeSlide - 1;
      setActiveSlide(newIndex);
      setSelectedMedia(selectedEvent.mediaFiles[newIndex].filePath);
    }
  };

  const handleMediaClick = (media, index) => {
    setSelectedMedia(media.filePath);
    setActiveSlide(index);
  };

  const closeLightbox = () => {
    setSelectedMedia(null);
    setActiveSlide(0);
  };

   // ✅ Gestion du chargement des médias (Shimmer)
   const [loadingMedia, setLoadingMedia] = useState({});

   const handleMediaLoad = (eventId, mediaIndex) => {
     setLoadingMedia((prev) => ({
       ...prev,
       [`${eventId}-${mediaIndex}`]: false, // Média chargé
     }));
   };
 
   const openMediaSlider = (index, image) => {
    setSelectedMedia(image);
    setActiveSlide(index);
  };
  




  // useEffect(() => {
  //   const fetchEvents = async () => {
  //     setLoading(true);
  //     try {
  //       const response = await fetch(`${BASE_URL}index.php?action=read_events&limit=3&page=${page}`);
  //       const data = await response.json();
  
  //       if (data.status === "success" && Array.isArray(data.data)) {
  //         setEvents((prevEvents) => {
  //           const mapEvent = (event) => ({
  //             id: event.id,
  //             title: event.title,
  //             description: event.description,
  //             date: event.event_date || "Date not specified", // ✅ standard
  //             coverImage: event.cover_image || "", // ✅ camelCase
  //             mediaFiles: Array.isArray(event.media_files)
  //               ? event.media_files.map((media) => ({
  //                   id: media.id,
  //                   filePath: media.file_path || "",
  //                   fileType: media.file_type || "photo"
  //                 }))
  //               : [],
  //           });
  
  //           if (page === 1) {
  //             return data.data.map(mapEvent); // ✅ Reset if first page
  //           }
  
  //           const newEvents = data.data
  //             .filter((event) => !prevEvents.some((e) => e.id === event.id))
  //             .map(mapEvent);
  
  //           return [...prevEvents, ...newEvents];
  //         });
  
  //         // ✅ Set pagination info
  //         setTotalPages(data.total_pages || 1);
  //         setCurrentPage(data.current_page || 1);
  //       } else {
  //         setError(data.message || "Failed to fetch events");
  //       }
  //     } catch (error) {
  //       console.error("Error fetching events:", error);
  //       setError("Error fetching events");
  //     } finally {
  //       setLoading(false);
  //     }
  //   };
  
  //   fetchEvents();
  // }, [page]);
  
  useEffect(() => {
    const fetchEvents = async () => {
      setLoading(true);
      try {
        const response = await fetch(`${BASE_URL}index.php?action=read_events&limit=3&page=${page}`);
        const data = await response.json();
  
        if (data.status === "success" && Array.isArray(data.data)) {
          // No events found
          // if (data.data.length === 0) {
          //   // If no events, go back to previous page
          //   setPage((prevPage) => Math.max(1, prevPage - 1));
          //   setLoading(false);
          //   return;
          // }
  
          setEvents((prevEvents) => {
            // If first page, reset list
            if (page === 1) {
              return data.data.map((event) => ({
                id: event.id,
                title: event.title,
                description: event.description,
                date: event.event_date || "Date not specified",
                coverImage: event.cover_image || "",
                mediaFiles: Array.isArray(event.media_files)
                  ? event.media_files.map((media) => ({
                      id: media.id,
                      filePath: media.file_path || "",
                      fileType: media.file_type || "photo"
                    }))
                  : [],
              }));
            }
  
            // Append new unique events
            const newEvents = data.data
              .filter((event) => !prevEvents.some((e) => e.id === event.id))
              .map((event) => ({
                id: event.id,
                title: event.title,
                description: event.description,
                date: event.event_date || "Date not specified",
                coverImage: event.cover_image || "",
                mediaFiles: Array.isArray(event.media_files)
                  ? event.media_files.map((media) => ({
                      id: media.id,
                      filePath: media.file_path || "",
                      fileType: media.file_type || "photo"
                    }))
                  : [],
              }));
  
            return [...prevEvents, ...newEvents];
          });
  
          // Update pagination info
          setTotalPages(data.total_pages || 1);
          setCurrentPage(data.current_page || 1);
        } else {
          // Handle case with no successful data
          setPage((prevPage) => Math.max(1, prevPage - 1));
          setError("");
        }
      } catch (error) {
        console.error("Error fetching events:", error);
        // Go back to previous page on error
        setPage((prevPage) => Math.max(1, prevPage - 1));
        setError("Error fetching events");
      } finally {
        setLoading(false);
      }
    };
  
    fetchEvents();
  }, [page]);
  


  useEffect(() => {
    const updateEventsPerPage = () => {
      if (window.innerWidth <= 768) {
        setEventsPerPage(1);
      } else if (window.innerWidth <= 1024) {
        setEventsPerPage(2);
      } else {
        setEventsPerPage(3);
      }
    };

    updateEventsPerPage();
    window.addEventListener("resize", updateEventsPerPage);
    return () => window.removeEventListener("resize", updateEventsPerPage);
  }, []);




  
  const scrollRight = () => {
    setPage((prevPage) => prevPage + 1);
    setCurrentIndex((prevIndex) =>
      prevIndex >= events.length - eventsPerPage ? 0 : prevIndex + 1
    );
  };
  
  const scrollLeft = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? events.length - eventsPerPage : prevIndex - 1
    );
  };
  


  return (
    <div className="evenements-container">
      {/* Header section remains the same */}
      <div className="Evheader-container">
        <h1 className="evenements-title">{t("eventsTitle")}</h1>
        <div className="Evnavigation-buttons">
          <button className="Evnav-btn" onClick={isArabic ? scrollRight : scrollLeft}>
            {isArabic ? "→" : "←"}
          </button>
          <button className="Evnav-btn" onClick={isArabic ? scrollLeft : scrollRight}>
            {isArabic ? "←" : "→"}
          </button>
        </div>
      </div>
      <br />

      {/* Grid section remains mostly the same */}
      <div className="evenements-grid">
        {events.slice(currentIndex, currentIndex + eventsPerPage).map((event) => (
          <div key={event.id} className="evenement-card">
            <div className="Evimage-container">
              <img src={event.coverImage} alt={event.title} className="evenement-image" />
              <div className="Evimage-overlay" />
            </div>
            <div className="evenement-info">
              <div className="text-content">
                <h3 className="evenement-title">{event.title}</h3>
                <p className="evenement-description">{event.description}</p>
                <p className="event-date"><strong>{event.date}</strong></p>
              </div>
              <button className="learn-more-btn" onClick={() => setSelectedEvent(event)}>
                <span className="nav">{isArabic ? "←" : "→"}</span>
              </button>
            </div>
          </div>
        ))}
      </div>

      {/* Modal with improved media handling */}
      {selectedEvent && (
        <div className="modal-overlay" onClick={() => setSelectedEvent(null)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="close-btn" onClick={() => setSelectedEvent(null)}>×</button>
            <img src={selectedEvent.coverImage} alt={selectedEvent.title} className="modal-image" />
            <h2 className="modal-title">{selectedEvent.title}</h2>
            <p className="modal-description">{selectedEvent.description}</p>
            <p className="modal-date"><strong>Date:</strong> {selectedEvent.date}</p>

            {selectedEvent.mediaFiles?.length > 0 && (
              <div className="media-gallery">
                {selectedEvent.mediaFiles.map((media, index) => (
                  <div key={index} className="media-item">
                   

                    {/* ✅ Effet Shimmer */}
                    {loadingMedia[`${selectedEvent.id}-${index}`] !== false && <div className="shimmer"></div>}

                    {/* Media (Image ou Vidéo) */}
                    {media.fileType === "photo" ? (
                      <img
                        src={media.filePath}
                        alt="Event media"
                        className={`media-image ${loadingMedia[`${selectedEvent.id}-${index}`] !== false ? "hidden" : ""}`}
                        onLoad={() => handleMediaLoad(selectedEvent.id, index)}
                        onClick={() => openMediaSlider(index, media.filePath)}
                        onError={(e) => (e.target.src = "/fallback-image.jpg")}
                      />
                    ) : null}
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      )}

      {/* Improved Lightbox */}
      {selectedMedia && selectedEvent && (
        <div className="lightbox-overlay" onClick={closeLightbox}>
          <div className="lightbox-content" onClick={(e) => e.stopPropagation()}>
            {selectedEvent.mediaFiles.length > 1 && (
              <>
                <button className="nav-btn left" onClick={goToPrevSlide}>←</button>
                <button className="nav-btn right" onClick={goToNextSlide}>→</button>
              </>
            )}
            {selectedMedia.endsWith(".mp4") ? (
              <video controls className="lightbox-media" autoPlay>
                <source src={selectedMedia} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            ) : (
              <img
                src={selectedMedia}
                alt="Enlarged media"
                className="lightbox-media"
                onError={(e) => {
                  e.target.src = "/fallback-image.jpg"; // Add fallback image
                }}
              />
            )}
            <button className="close-btn" onClick={closeLightbox}>×</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Evenements;
